import React from 'react';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="border-b border-line bg-ink px-3 py-14 sm:px-6 sm:py-20" data-id="element-57" data-mp="au1v6pqlckjy">
      <SectionHeading eyebrow="🎁 Bonus exclusifs" title="En plus, vous recevrez gratuitement ces 5 bonus exclusifs" subtitle="Conçus pour éliminer les doutes qui paralysent le plus souvent les médecins dans la pratique clinique quotidienne." data-id="element-58" data-mp="ftmresedmesz" />

      <ul className="mx-auto mt-10 flex w-full max-w-3xl flex-col gap-6" data-id="element-59" data-mp="3o1lf0qlfzjix">
        {bonuses.map(bonus => <li key={bonus.title} className="overflow-hidden rounded-3xl border border-line bg-surface" data-id="element-60" data-mp="3t0g5mepnicdl">
            <div className="bg-white" data-id="element-61" data-mp="1mbjoevajq1s8">
              <img src={bonus.image} alt={`Mockup du bonus ${bonus.title}`} className="block w-full" width={1260} height={1260} loading="lazy" data-id="element-62" data-mp="1m8fgpnxvgnwt" />
            </div>

            <div className="p-5 sm:p-7" data-id="element-63" data-mp="3df3ajqa1bjkj">
              <div className="flex flex-wrap items-center justify-between gap-2" data-id="element-64" data-mp="3r6i7l10s1lal">
                <span className="inline-flex items-center gap-2 rounded-full bg-lime/12 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.16em] text-lime" data-id="element-65" data-mp="3r8ktp9yt6ua1">
                  <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-66" data-mp="2zgdgykmfc20x" />
                  {bonus.tag}
                </span>
                <span className="text-[11px] font-bold uppercase tracking-[0.12em] text-slate-500" data-id="element-67" data-mp="2uikarrl4f80n">
                  Valeur : <span className="text-slate-300 line-through" data-id="element-68" data-mp="38dw4pwrgcugi">{bonus.value}</span>
                </span>
              </div>

              <h3 className="mt-4 font-display text-2xl font-extrabold leading-tight text-white sm:text-3xl" data-id="element-69" data-mp="npi3eb9zxus4">
                {bonus.title}
              </h3>
              <p className="mt-3 text-[15px] font-semibold leading-relaxed text-lime sm:text-base" data-id="element-70" data-mp="it15wqgwq42d">
                {bonus.lead}
              </p>
              <p className="mt-3 text-[15px] leading-relaxed text-slate-400" data-id="element-71" data-mp="3hh81t2n4vy2f">{bonus.body}</p>
            </div>
          </li>)}
      </ul>

      <div className="mx-auto mt-10 max-w-xl" data-id="element-72" data-mp="3lke1tsjnkt0g">
        <CTAButton label="Je veux mes 5 bonus gratuits" caption="195 € de bonus inclus sans frais supplémentaires" data-id="element-73" data-mp="3qj7ituy5f25d" />
      </div>
    </section>;
}